import React, { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BackNavigation } from '../components/shared';
import { AppPage } from '../layouts/types';
import AuthenticationService from '../services/Authentication';
import Icon from 'assets/icons';

let currentOtpIndex = 0;

const VerifyOtp: AppPage = () => {
  const authService = new AuthenticationService();

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [activeOtpIndex, setActiveOtpIndex] = useState<number>(0);

  const [active, setActive] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const inputRef = useRef<HTMLInputElement>(null);
  const router = useNavigate();

  const [searchParams] = useSearchParams();
  const title = searchParams.get("title");
  const link = searchParams.get("link");
  const type = searchParams.get("type");
  const userId: any = searchParams.get("userId");
  const email: any = searchParams.get("email");

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  });

  const handleChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = target;

    const newOtp: string[] = [...otp];
    newOtp[currentOtpIndex] = value.substring(value.length - 1);
    setOtp(newOtp);

    if (!value) setActiveOtpIndex(currentOtpIndex - 1);
    else setActiveOtpIndex(currentOtpIndex + 1);

    setActive(true);
  };

  const handleOnKeyDown = (
    { key }: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    currentOtpIndex = index;
    if (key === "Backspace") setActiveOtpIndex(currentOtpIndex - 1);
  };

  // Resend logic
  const resendOTP = async () => {
    setMinutes(0);
    setSeconds(29);

    if (type === "forgotPassword") {
      const response: any = await authService.requestForgotPasswordOTP(email);

      if (response.success) toast.success(response.message);
      else toast.error(response.message || "Something went wrong");
    } else {
      await authService.resendOtp(type ?? "signup");
    }
  };

  // Verify logic
  const handleClick = async () => {
    setOtp([...otp.map(() => " ")]);
    setActive(false);

    const enteredOtp = otp.join("");

    if (type === "signup") {
      const response = await authService.verifyOtpNew(enteredOtp, userId);

      if (response.code) {
        toast.success(response.message + new Date().toDateString());
        link ? router(link) : router("/login");
      } else {
        toast.error(response.message);
      }
    }

    if (type === "forgotPassword") {
      const response: any = await authService.verifyForgotPasswordOTP(email, enteredOtp);

      if (response.success) {
        toast.success(response.message);
        router("/set-newpassword", { state: { email } });
      } else {
        toast.error(response.message || "Invalid OTP");
      }
    }
  };

  const resendClasses =
    seconds > 0 ? "text-app-gray" : "text-app-blue hover:scale-105";

  const classes =
    active === false ? "bg-app-blue" : "bg-app-blue hover:scale-105";

  return (
    <div className="flex flex-col h-full mobile:p-4 tablet:p-6 laptop:p-10">
      <div className="mb-6">
        <BackNavigation title={"Back"} />
      </div>

      <div className="flex flex-1 justify-center items-center">

        <div className="flex flex-col space-y-5 w-full max-w-md tablet:max-w-lg laptop:max-w-xl ">
          <div className="mb-6 flex justify-center">
            <img width={252} height={64} src={Icon.secondLogo} alt="Icon Image" />
          </div>

          <h1 className="text-2xl tablet:text-3xl laptop:text-4xl font-bold text-zinc-600 justify-start">
            <span className="text-app-blue font-bold">OTP </span>
            <span className="text-app-blue font-light">Verification </span>
          </h1>

          <p className="text-lg tablet:text-base font-lato text-app-blue items-start">
            Enter the OTP received on your email ID
          </p>

          <div className="flex justify-start gap-6 tablet:gap-3 laptop:gap-4 w-full">
            {otp.map((_, index) => (
              <input
                ref={index === activeOtpIndex ? inputRef : null}
                key={index}
                className="
              h-14 w-14 
              tablet:h-14 tablet:w-14 
              laptop:h-16 laptop:w-16
              border border-app-gray 
              focus:outline-app-blue             
              rounded-xl tablet:rounded-2xl 
              bg-white text-center 
              text-lg tablet:text-xl laptop:text-2xl
            "
                value={otp[index]}
                type="text"
                maxLength={1}
                name="otp"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleOnKeyDown(e, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>


          <div className="flex flex-col items-start justify-start space-y-1 whitespace-nowrap">
            {(seconds > 0 || minutes > 0) && (
              <p className="text-app-blue font-semibold text-base tablet:text-lg">
                {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds} sec
              </p>
            )}

            <p className="text-lg tablet:text-base text-zinc-600 whitespace-nowrap">
             <span className="text-app-blue font-semibold block laptop:hidden"> Didn&apos;t receive the OTP? </span>
              <button
                disabled={seconds > 0 || minutes > 0}
                className={`${resendClasses} px-2 font-bold underline `}
                onClick={resendOTP}               
              >
                
                Resend OTP
              </button>
            </p>
          </div>
          
          <button
            // disabled={!active}
            onClick={handleClick}
            className={`
          w-[190px] 
          tablet:w-3/4 
          laptop:w-2/3
          rounded-full py-2 
          bg-app-blue text-white font-bold 
          ${classes}
        `}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
